import Icon from '../components/Icon.vue'

Icon.register({"exclamation":{"width":192,"height":512,"paths":[{"d":"M176 432C176 476.1 140.1 512 96 512S16 476.1 16 432 51.9 352 96 352 176 387.9 176 432zM25.3 25.2L38.9 297.2C39.5 310 50 320 62.8 320H129.2C142 320 152.5 310 153.1 297.2L166.7 25.2C167.4 11.5 156.5 0 142.8 0H49.2C35.5 0 24.6 11.5 25.3 25.2z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/exclamation.js
// module id = T3PN
// module chunks = 0